<template>
  <router-link
    v-if="info.url"
    :to="info.url"
    class="d-flex align-center font-color-inherit font-weight-normal blue-on-hover"
  >
    <span class="truncate">{{ info.label }}</span>
    <tm-icon
      size="xSmall"
      name="north_east"
      class="distinct--text ml-1"
    />
  </router-link>
  <tm-button
    v-else-if="info.onClick"
    class="primary--text"
    text-link
    :disable="info.isDisabled"
    @click="info.onClick"
  >
    <span class="truncate font-size-small-x">{{ info.label }}</span>
  </tm-button>
  <span
    v-else
    class="truncate"
    :style="info.labelStyle"
  >
    {{ info.label }}
  </span>
</template>

<script setup lang="ts">
import TmIcon from '@/components/shared/TmIcon.vue'
import TmButton from '@/components/shared/TmButton.vue'
import type { DetailsHeroInfo } from '@/components/shared/templates/details/type'

const props = defineProps<{
  info: DetailsHeroInfo
}>()
</script>
